import { navigateAction } from 'fluxible-router';
import { getNetwork } from 'app/scripts/services/app-state';
import { resolveContext } from 'app/scripts/services/context-provider';
import config from 'config/config';
import { retryLogin } from '../../resources/interceptors/login-interceptor';
import { dispatch, getState } from 'state/store';
import { setRetryAuth } from 'state';

const authInterceptor = async (): Promise<void> => {
  const networkName = getNetwork().name;
  const context = await resolveContext();
  const isRetrying = getState().application.isRetryAuth;

  if (isRetrying) {
    return;
  }

  dispatch(setRetryAuth(true));

  const isAuth = await retryLogin();

  dispatch(setRetryAuth(false));

  if (isAuth) {
    return;
  }

  const url = config.api.basic;
  let route;

  if (networkName) {
    route = `network/${networkName}`;
  } else {
    route = `network/spotim`;
  }

  if (context) {
    return context.executeAction(navigateAction, { url: `/${route}` });
  }

  window.location = url + route;
};

export default authInterceptor;
